import { type FC } from "react"
import { useTheme } from "styled-components"
import Values from "values.js"

import { toNumberFormat } from "@forento/shared/utilities/number"

import { usePlatform } from "~/contexts/PlatformContext"
import { useUser } from "~/contexts/UserContext"
import { useTranslation } from "~/translations"
import { query } from "~/utilities/trpc"

const Gamification: FC = () => {
	const platform = usePlatform().platform
	const user = useUser().user
	const t = useTranslation()
	const theme = useTheme()

	const { data } = query.community.getProfile.useQuery(user?.communityProfileId ?? -1, {
		enabled: platform.community?.isGamificationEnabled ?? false,
	})

	if (!data?.gamification) return null

	return (
		<div className="flex w-full flex-col items-center rounded-lg bg-white p-6 md:max-w-lg">
			<h2 className="mb-6 self-start font-semibold">{t("dashboard.communityPoints")}</h2>
			<div className="mb-6 flex flex-col items-center">
				<div className="text-xl font-bold">
					<span className="text-primary">{toNumberFormat(data.gamification.points)}</span>
					{data.gamification.nextLevel && <> / {toNumberFormat(data.gamification.nextLevel.unlockPoints)}</>}
				</div>
				{data.gamification.nextLevel && (
					<div className="text-light mt-1 text-center">
						{t("dashboard.nextLevel", {
							level: data.gamification.nextLevel.label,
						})}
					</div>
				)}
			</div>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="127"
				height="127"
				viewBox="0 0 127 127"
				fill="none"
				className="text-pretty"
			>
				<circle cx="63.5" cy="63.5" r="63.5" fill={new Values(theme.primaryColor).tint(75).hexString()} />
				<path
					d="M65.8328 45.0819C65.8328 45.0819 65.1914 45.2423 64.2293 45.4026C64.8707 47.1665 65.1914 49.4114 65.3517 51.8167C67.5967 49.0907 72.0865 48.77 73.69 49.8925C73.69 49.8925 72.0865 55.8255 65.5121 54.8634C65.5121 56.7876 65.3517 58.7119 65.031 60.3154H61.6636C62.4654 56.1462 62.4654 47.9683 60.3808 44.9216C50.439 42.3559 49.4769 33.0555 49.4769 33.0555C57.3341 32.4141 60.2205 35.1401 61.9843 40.111C62.9464 27.2828 75.4539 26 75.4539 26C78.5006 35.9418 73.5297 42.3559 65.8328 45.0819Z"
					fill={theme.primaryColor}
				/>
				<path
					d="M47.5527 76.1903L51.5615 99.4413C51.7218 100.083 52.2029 100.564 52.8443 100.564H73.0487C73.6901 100.564 74.3315 100.083 74.4919 99.4413L78.9817 76.1903C79.1421 75.5488 78.661 75.0678 78.0196 75.0678H48.5148C47.8734 74.9074 47.3923 75.5488 47.5527 76.1903Z"
					fill={theme.primaryColor}
				/>
				<path
					d="M45.1474 72.1815H81.387C82.0284 72.1815 82.5095 71.7004 82.5095 71.059V63.8431C82.5095 63.2017 82.0284 62.7207 81.387 62.7207H45.1474C44.506 62.7207 44.0249 63.2017 44.0249 63.8431V71.059C43.8646 71.7004 44.506 72.1815 45.1474 72.1815Z"
					fill={theme.primaryColor}
				/>
			</svg>
		</div>
	)
}

export default Gamification
